import { useSuspenseQuery } from "@tanstack/react-query";
import { route } from "../../../../../../shim/jsbridge";
import { queryOptions } from "../../../../../search/hooks";
import { Analysis, JoeDomains } from "../../../../@types";
import api from "../../../../api";
import { sampleReportKeys } from "../../../../queryKeys";

const useGetDomainData = <T extends JoeDomains>(
  hash: string | undefined,
  type: T,
  analysis: Analysis,
  uploadId?: string
) => {
  const endpoint = hash
    ? route(`api_${analysis}_domain_${type}`, [hash])
    : route(`api_${analysis}_url_domain_${type}`, [uploadId]);

  const { data } = useSuspenseQuery({
    ...queryOptions,
    queryKey: sampleReportKeys.domainData(endpoint),
    queryFn: () => api.getDynamicAnalysisData<Array<unknown>>(endpoint),
    select: ({ data: domainData }) => domainData
  });

  return { data };
};

export default useGetDomainData;
